export type ProjectStatus =
  | 'Enquiry'
  | 'Upcoming'
  | 'InProgress'
  | 'Completed'
  | 'Closed'
  | 'Cancelled';

export type Project = {
  beginDate?: string;
  complDate?: string;
  actualStartDt?: string;
  actualStartDtStr?: string;
  assignedUntilDt?: string;
  assignedUntilDtStr?: string;
  alertFlg?: boolean;
  alertMsg?: string;
  orgzAlias?: string;
  orgzId?: string;
  customerAlias?: string;
  customerCode?: string;
  customerId?: string;
  customerName?: string;
  createdTime?: string;
  name?: string;
  organizationId?: string;
  code?: string;
  projectId?: string;
  colorCode?: string;
  bgColor?: string;
  billCycle?: string;
  borderColor?: string;
  remarks?: string;
  reqStatus?: string;
  reqStatusMsg?: string;
  sites?: Site[];
  status?: { name: ProjectStatus; colorHex: string };
  createdBy?: string;
  lastModTime?: string;
  lastModifiedBy?: string;
  lastModifiedDate?: string;
};

export type Shift = {
  shiftId: string;
  name: string;
  code: string;
  fromTime: string;
  toTime: string;
  colorCode: string;
};

export type Site = {
  siteId: string;
  name: string;
  code: string;
  beginDate: string;
  complDate: string;
  lastModTime: string;
  lastModifiedBy: string;
  lastModifiedDate: string;
  createdBy: string;
  createdDate: string;
  createdTime: string;
  status?: { name: ProjectStatus; colorHex: string };
  radius?: number;
  location: [number, number];
  locPolygon?: [number, number][];
  shift: {
    shiftId: string;
    name: string;
    code: string;
    fromTime: string;
    toTime: string;
    colorCode: string;
  };
  checkInLocTrack?: boolean;
  checkOutLocTrack?: boolean;
  checkInFaceId?: boolean;
  checkOutFaceId?: boolean;
  timeInMode?: 'Auto' | 'Manual';
  timeOutMode?: 'Auto' | 'Manual';
};

export type ProjectFilter = {
  status: string;
  color: string;
  count: number;
};

export class ProjectQuery {
  filter?: string = '';
  pageNumber?: number = 1;
  pageSize?: number = 20;
  sortOrder?: 'desc' | 'asc' = 'asc';
  sortField?: string = 'pj.name';
  status?: string[] = ['InProgress'];
  orgId?: string[] = [];
  fromDt?: string;
  toDt?: string;
}

export type TimeRule = {
  name: string;
  projId: string;
  siteId: string;
  dayRuleId: string;
  hourRuleId: string;
  validFrom: string;
  validTo: string;
  remarks: string;
};
